module.exports = __webpack_public_path__ + "static/img/sh_ytg.18f7298.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sh_ytg.png
// module id = lGim
// module chunks = 167